import { Button, Icon, Popover } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import autobind from "autobind-decorator";
import ProgramWrapper from "common/entities/programWrapper/ProgramWrapper";
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { IQueryOne, QueryOne } from "core/api/query";
import { PanelSetupRequired } from "core/components/editor/EditToggle";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { nDef } from "core/util/TypeUtils";
import { CardVariant, CardView } from "../../common/views/card/Card.view";
import HeadingView, { HeadingVariant } from "../../common/views/heading/Heading.view";
import ProgressBarView from "../../common/views/progressBar/ProgressBar.view";
import Program from "./entities/Program";
import labelProvider from './ProgramStatus.labels';
import ProgramStatusConfig from "./ProgramStatusConfig";
interface IListItemProps {
	complete: boolean;
	title: string | JSX.Element;
}

const { Labels } = labelProvider;
const ListItem: React.SFC<IListItemProps> = ({complete, title}) => (
	<BlockView variant={BlockVariant.DEFAULT} viewKey={"list-item"}>
		<div style={{display: 'flex', alignItems: "center"}}>
			<Icon iconSize={28} icon={complete ? IconNames.TICK_CIRCLE : IconNames.CIRCLE}/>
			<div style={{flexGrow: 1, marginLeft: "5px"}}>
				<HeadingView variant={HeadingVariant.H4} viewKey="list-item-title" children={title} />
			</div>
		</div>
	</BlockView>
);

function mergeConfigAndParams(config: ProgramStatusConfig, pageParams: { [key: string]: string; }) {
	return {id: config.programId};
}

@Panel({id: "programStatus", configClass: ProgramStatusConfig, labelProvider})
@QueryOne(Program, mergeConfigAndParams)
class ProgramStatusPanel extends React.Component<IPanelProps<ProgramStatusConfig> & IQueryOne<Program>> {

	@autobind
	private getQueryParams() {
		return {id: this.props.config.programId};
	}

	public render() {
		const { programId, tracks, tests, maxTracks } = this.props.config;

		if(nDef(programId)) {
			return (
				<PanelSetupRequired description="Specify a panel to get started." />
			);
		}

		const wrapper = new ProgramWrapper(this.props.entity);

		const cards = wrapper.getProgress().map((p) => (
			<CardView variant={CardVariant.MINIMAL} viewKey="track" key={p.id}>
				<HeadingView viewKey="track-name">
					{p.name}
				</HeadingView>

				<ProgressBarView viewKey="track-progress" value={p.total > 0 ? p.completed / p.total : 0}/>

				<HeadingView viewKey="track-details">
					<Labels.CompletionStatus args={{Completed: p.completed , Total: p.total}}/>
				</HeadingView>
			</CardView>
		));

		return (
			<div>
				{tests && (
					<ListItem complete={wrapper.getPreTestWrapper() && wrapper.getPreTestWrapper().isCompleted()} title={
						<Labels.PreTest/>
					}/>
				)}

				{tracks ? (
					cards.length > maxTracks ? (
						<div>
							{cards.slice(0, maxTracks)}

							<Popover content={
								<div style={{padding: "10px"}}>
									{cards.slice(maxTracks, cards.length)}
								</div>
							} target={
								<Button icon={IconNames.MORE} minimal={true} />
							}/>
						</div>
					) : (
						<div>
							{cards}
						</div>
					)
				) : (
					<ListItem complete={wrapper.getAggregateProgressPercent() >= 1} title={
						<Labels.StudyPractice/>
					}/>
				)}

				{tests && (
					<ListItem complete={wrapper.getPostTestWrapper() && wrapper.getPostTestWrapper().isCompleted()} title={
						<Labels.PostTest/>
					}/>
				)}
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/panels/programStatus/ProgramStatus.panel.tsx